import * as log from "loglevel";

/**
 * Queue for tracking calls that occur before dtm tracking script is loaded
 * @type {Array}
 */
const trackingQueue = [];

/**
 * If there's been tracking calls before tracking script was loaded they will have been added to a queue.
 * Iterate over the queue and track each one now that the tracking script has been loaded
 */
export const executeTrackingQueue = () => {
  if (trackingQueue.length > 0) {
    trackingQueue.forEach(({ datalayer, event }) => {
      window.datalayer = datalayer;
      window._satellite.track(event);
    });
  }
};

/**
 * Track using dtm satellite lib
 */
export const performLibTrack = (event, data) => {
  window.datalayer = data ? data : window.datalayer;
  window._satellite.track(event);
};

/**
 * If the DTM script has been loaded, track. Otherwise, add the track to a queue which will be invoked once DTM has been loaded
 * @param event
 * @param data
 */
export const tryTrack = (event, data) => {
  const datalayer = data ? data : window.datalayer;
  try {
    performLibTrack(event, datalayer);
  } catch (e) {
    trackingQueue.push({
      datalayer,
      event,
    });
    log.log(
      "%c DEBUG ",
      "color: white; background-color: #009ce0",
      `DTM not available - Queued tracking ${event} with:`,
      datalayer
    );
  }
};

export function generateTrackingDataLayer({ claim_product, claim_process }) {
  const { pathname } = window.location;
  const paths = pathname.split("/");
  paths.unshift("Applikationer");
  const pagename = paths
    .slice(0, paths.length - 1)
    .filter((x) => x !== "")
    .join("|");
  const sections = constructSections(
    pathname
      .split("/")
      .slice(0, paths.length - 1)
      .filter((x) => x !== "")
  );
  //TODO insert sitesection
  const base = {
    pageType: "Skadeanmälan",
    pagename: pagename,
    website: "3kronor.se",
    ...sections,
  };
  return { ...base, claim_product, claim_process };
}
export const constructSections = (sections) => {
  const template = [
    ["Applicationer"],
    ["Applicationer", null],
    ["Applicationer", null, null],
    ["Applicationer", null, null, null],
    ["Applicationer", null, null, null, null],
  ];

  return template.reduce((result, row, index) => {
    sections.forEach((section, sectionIndex) => {
      if (row[sectionIndex + 1] === null) {
        row[sectionIndex + 1] = section;
      }
    });

    result[`sitesection${index + 1}`] = row.join("|");
    return result;
  }, {});
};
export function trackPageBottom() {
  window._satellite.pageBottom();
}
